module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__root",
    style: ({
      paddingBottom: _vm.navHeight
    }),
    attrs: {
      "id": "app"
    }
  }, [(_vm.sharedState.showMainNav) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('headerNav')], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slider-fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29777652","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 418
// module chunks = 1